module.exports = __webpack_public_path__ + "static/media/heart23.5131804e.svg";